import { appConfig } from "../appConfig";

const FORMS_API_VERSION = "2";
export const FORMS_API_BASE_ENDPOINT = `${appConfig.env.API_URL}/novaforms/v${FORMS_API_VERSION}`;
